module.exports = __webpack_public_path__ + "static/media/forgot_password.19c815c5.svg";